export default __webpack_public_path__ + "static/poe-splitter-12v-59c12a5c8937b7c3045d8ebcf94501db.webp";